import type { FormData, RedirectConfig, GenericObjectType } from '@/types';

export const emitEvent = (name: string, data: any) => {
  const event = new CustomEvent(name, { detail: data });
  document.dispatchEvent(event);
};

const showSuccessMessage = (formId: string, data: GenericObjectType) => {
  const message =
    data.message ||
    '<p class="yepcode-form-success-message">The form has been successfully submitted</p>';
  (
    (document.getElementById(formId) as HTMLElement)
      .parentElement as HTMLElement
  ).innerHTML = message;
};

const manageRedirect = (redirectConfig: RedirectConfig) => {
  setTimeout(() => {
    window.location.assign(redirectConfig.url);
  }, redirectConfig.timeout || 0);
};

const manageJavaScriptCallback = (jsCallback: string) => {
  eval(jsCallback);
};

export const onSuccessDefault = (
  formId: string,
  processExecutionResult: GenericObjectType,
  formSubmittedData: FormData
) => {
  console.log(`Form ${formId} has been successfully submitted.`);
  emitEvent('yepcode-forms-on-submit-success', {
    formId,
    formSubmittedData,
    processExecutionResult,
  });
  showSuccessMessage(formId, processExecutionResult);
  processExecutionResult.jsCallback &&
    manageJavaScriptCallback(processExecutionResult.jsCallback);
  processExecutionResult.redirect &&
    manageRedirect(processExecutionResult.redirect);
};

export const onNextStepDefault = (
  formId: string,
  previousProcessExecutionResult: GenericObjectType
) => {
  previousProcessExecutionResult.jsCallback &&
    manageJavaScriptCallback(previousProcessExecutionResult.jsCallback);
  emitEvent('yepcode-forms-on-next-step', {
    formId,
    previousProcessExecutionResult,
  });
};

export const onErrorDefault = (formId: string, error: unknown) => {
  console.log(`There has been an error submitting the form ${formId}`, error);
  emitEvent('yepcode-forms-on-submit-error', { formId, error });
  let errorMessage = 'There has been an error submitting the form';
  try {
    // @ts-ignore: Try to read an errorMessage inside the error
    const jsonError = JSON.parse(error.message);
    if (jsonError.errorMessage) {
      errorMessage = jsonError.errorMessage;
    }
  } catch (error) {
    // Do nothing
  }
  (
    (document.getElementById(formId) as HTMLElement)
      .parentElement as HTMLElement
  ).innerHTML = `<p class="yepcode-form-error-message">${errorMessage}</p>`;
};

const mapFieldErrorsToExtraErrors = (object: any) => {
  if (object !== null) {
    switch (typeof object) {
      case 'string':
        object = {
          __errors: [object],
        };
        break;
      case 'object':
        if (object instanceof Array) {
          object = {
            __errors: [...object],
          };
          break;
        } else {
          for (const i in object) {
            object[i] = mapFieldErrorsToExtraErrors(object[i]);
          }
        }
        break;
    }
  }

  return object;
};

export interface YepCodeFormErrors {
  global: string[];
  fields: GenericObjectType;
}

export const mapFormErrorsToExtraErrors = (
  formErrors: YepCodeFormErrors
): GenericObjectType => {
  let extraErrors: GenericObjectType = {};
  if (formErrors['fields']) {
    extraErrors = { ...mapFieldErrorsToExtraErrors(formErrors['fields']) };
  }
  if (formErrors['global']) {
    extraErrors['__errors'] = [...formErrors.global];
  }
  return extraErrors;
};
